//Horizontal scroll mobile

document.addEventListener("DOMContentLoaded", () => {
    const mgalleries = document.querySelectorAll('.main-product--mobile');
    mgalleries.forEach(gallery => {
      const container = gallery.querySelector('.main-product--mobile .product-media--variants .product-media--container');
      const thumbs = gallery.querySelectorAll('.main-product--mobile .product-media--thumb');
      const slides = gallery.querySelectorAll('.main-product--mobile .product-media--root');

      if (!container || !thumbs.length || !slides.length) return;

      // --- 1️⃣ Clicking thumb scrolls main image
      thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
          container.scrollTo({
          left: slides[index].offsetLeft,
          behavior: 'smooth'
          });
          setActiveThumb(index);
      });
      });

      // --- 2️⃣ When scrolling, update active thumb
      container.addEventListener('scroll', () => {
      const scrollLeft = container.scrollLeft;
      const slideWidth = slides[0].offsetWidth;
      const currentIndex = Math.round(scrollLeft / slideWidth);
      setActiveThumb(currentIndex);
      });

      // --- Helper to update active state
      function setActiveThumb(index) {
      thumbs.forEach((t, i) => t.dataset.active = i === index ? 'true' : 'false');
      }
    });
});

/* tidio chat */
document.addEventListener("DOMContentLoaded", () => {
  const WRAPPER_SELECTOR = "#tidio-chat";

  // 1️⃣ Hide Tidio once it loads
  const observer = new MutationObserver(() => {
    const wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (wrapper) {
      wrapper.style.display = "none";
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // 2️⃣ Listen for #tidio link clicks
  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href="#tidio"]');
    if (!link) return;
    e.preventDefault();

    const wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (wrapper) wrapper.style.display = "block"; // temporarily show, optional

    // Try to open chat via Tidio API (only reliable way)
    if (window.tidioChatApi) {
      window.tidioChatApi.open();
    } else {
      // Wait until Tidio fully initializes
      document.addEventListener("tidioChat-ready", () => {
        window.tidioChatApi.open();
      });
    }
  });

  // 3️⃣ Hide wrapper again when chat is closed
  document.addEventListener("tidioChat-close", () => {
    const wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (wrapper) wrapper.style.display = "none";
  });
});




/* function for info drawer */

window.openInfoDrawer = function(id, title) {
  // Reset the info drawer
  document.querySelector(".dir_header h3").innerHTML = "";
  document.querySelector(".dir_content").innerHTML = "";

  // Write new content
  document.querySelector(".dir_header h3").innerHTML = title;

  const sourceEl = document.querySelector(`#idr-${id}`);
  const content = sourceEl ? sourceEl.innerHTML : "";

  document.querySelector(".dir_content").innerHTML = content;
}


//sync cart qty
document.addEventListener("DOMContentLoaded", () => {
  const source = document.querySelector(".header--cart[data-cart-count]");
  if (!source) return;

  const sync = () => {
    const count = source.getAttribute("data-cart-count");
    document.querySelectorAll("[data-cart-count]").forEach(el => {
      if (el !== source) el.setAttribute("data-cart-count", count);
    });
  };

  sync();

  new MutationObserver(sync).observe(source, {
    attributes: true,
    attributeFilter: ["data-cart-count"]
  });
});


document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 768) return; // mobile only

  const form = document.querySelector(".section--custom-form .product-form");
  if (!form) return;

  const description = form.querySelector('[data-block-type="description"]');
  const addToCart = form.querySelector('[data-block-type="buy-buttons-with-qty"]');

  if (!description || !addToCart) {
    console.log("Blocks not found");
    return;
  }

  // Move description ABOVE add to cart
  form.insertBefore(description, addToCart);

  const productIcons  = form.querySelector('[data-block-type="product-icons"]');
  if (productIcons) {
      addToCart.insertAdjacentElement("afterend", productIcons);
  }
});



(() => {
  if (!window.customElements || !customElements.get("cart-element")) return;

  const CartProto = customElements.get("cart-element")?.prototype
    || window.Cart?.prototype;

  if (!CartProto || !CartProto.updateShipping) return;

  const original = CartProto.updateShipping;

  CartProto.updateShipping = function (oldNode, newNode) {
    if (oldNode && newNode) {
      oldNode.replaceWith(newNode);
      return;
    }
    // fallback to original behavior if something unexpected happens
    return original?.call(this, oldNode, newNode);
  };
})();



/* JS scrollbar */
document.querySelectorAll('.js-scrollbar').forEach(wrapper => {
  const section = wrapper.closest('.featured-collection--wrapper');
  const slider = section?.querySelector('[data-display-type="slider"]');
  const thumb = wrapper.querySelector('.js-thumb');

  if (!slider || !thumb) return;

  const updateThumb = () => {
    const visibleRatio = slider.clientWidth / slider.scrollWidth;
    const trackWidth = wrapper.clientWidth;

    const thumbWidth = Math.max(trackWidth * visibleRatio, 30); // min size
    thumb.style.width = `${thumbWidth}px`;

    const maxScroll = slider.scrollWidth - slider.clientWidth;
    const percent = slider.scrollLeft / maxScroll;

    thumb.style.transform =
      `translateX(${percent * (trackWidth - thumbWidth)}px)`;
  };

  slider.addEventListener('scroll', updateThumb);
  window.addEventListener('resize', updateThumb);

  updateThumb(); // init
});



/* Featured products with tabs */
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".btn-tab");
  if (!btn) return;

  // find parent section
  const section = btn.closest('[data-section-id]');
  if (!section) return;

  const tab = btn.dataset.tab; // 1, 2, etc

  // hide all tab content in this section
  section.querySelectorAll('[data-tab-content]').forEach(el => {
    el.style.display = "none";
  });

  // remove active state
  section.querySelectorAll('.btn-tab').forEach(b => {
    b.classList.remove('active');
  });

  // show current tab
  section.querySelectorAll(`[data-tab-content="${tab}"]`).forEach(el => {
    el.style.display = "";
  });

  btn.classList.add('active');
});



/* Product video mute / unmute */
const ICON_SOUND_ON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M533.6 96.5C523.3 88.1 508.2 89.7 499.8 100C491.4 110.3 493 125.4 503.3 133.8C557.5 177.8 592 244.8 592 320C592 395.2 557.5 462.2 503.3 506.3C493 514.7 491.5 529.8 499.8 540.1C508.1 550.4 523.3 551.9 533.6 543.6C598.5 490.7 640 410.2 640 320C640 229.8 598.5 149.2 533.6 96.5zM473.1 171C462.8 162.6 447.7 164.2 439.3 174.5C430.9 184.8 432.5 199.9 442.8 208.3C475.3 234.7 496 274.9 496 320C496 365.1 475.3 405.3 442.8 431.8C432.5 440.2 431 455.3 439.3 465.6C447.6 475.9 462.8 477.4 473.1 469.1C516.3 433.9 544 380.2 544 320.1C544 260 516.3 206.3 473.1 171.1zM412.6 245.5C402.3 237.1 387.2 238.7 378.8 249C370.4 259.3 372 274.4 382.3 282.8C393.1 291.6 400 305 400 320C400 335 393.1 348.4 382.3 357.3C372 365.7 370.5 380.8 378.8 391.1C387.1 401.4 402.3 402.9 412.6 394.6C434.1 376.9 448 350.1 448 320C448 289.9 434.1 263.1 412.6 245.5zM80 416L128 416L262.1 535.2C268.5 540.9 276.7 544 285.2 544C304.4 544 320 528.4 320 509.2L320 130.8C320 111.6 304.4 96 285.2 96C276.7 96 268.5 99.1 262.1 104.8L128 224L80 224C53.5 224 32 245.5 32 272L32 368C32 394.5 53.5 416 80 416z"/></svg>`;

const ICON_MUTED = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M80 416L128 416L262.1 535.2C268.5 540.9 276.7 544 285.2 544C304.4 544 320 528.4 320 509.2L320 130.8C320 111.6 304.4 96 285.2 96C276.7 96 268.5 99.1 262.1 104.8L128 224L80 224C53.5 224 32 245.5 32 272L32 368C32 394.5 53.5 416 80 416zM399 239C389.6 248.4 389.6 263.6 399 272.9L446 319.9L399 366.9C389.6 376.3 389.6 391.5 399 400.8C408.4 410.1 423.6 410.2 432.9 400.8L479.9 353.8L526.9 400.8C536.3 410.2 551.5 410.2 560.8 400.8C570.1 391.4 570.2 376.2 560.8 366.9L513.8 319.9L560.8 272.9C570.2 263.5 570.2 248.3 560.8 239C551.4 229.7 536.2 229.6 526.9 239L479.9 286L432.9 239C423.5 229.6 408.3 229.6 399 239z"/></svg>`;

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.video-mute-toggle');
  if (!btn) return;

  const root = btn.closest('product-video-element');
  if (!root) return;

  const video = root.querySelector('video');
  if (!video) return;

  // toggle mute
  video.muted = !video.muted;

  // update icon
  btn.innerHTML = video.muted ? ICON_MUTED : ICON_SOUND_ON;

  // keep playing
  if (video.paused) {
    video.play().catch(() => {});
  }
});


/* Custom script for test disable the subscription option for following products */
/*
(function hideSubscriptionBtn() {

  console.log("Hide susbcription btn");

  const productId = document.querySelector('input[name="product-id"]')?.value;
  if (!productId) return;

  const ELIGIBLE_PRODUCTS = [
    "10060640157880",
    "10060869992632",
    "10109389340856",
    "10109401956536",
    "10109402742968",
    "10215618904248"
  ];

  if (!ELIGIBLE_PRODUCTS.includes(productId)) return;

  function hideSub() {
    if (document.getElementById("hide-subscription-style")) return;

    const style = document.createElement("style");
    style.id = "hide-subscription-style";
    style.innerHTML = `
      .loop-widget-purchase-options-container,
      .ghost-btn.subscribe {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
    
    const waitForDrawer = (cb) => {
      const iv = setInterval(() => {
        const drawer = document.querySelector(".mobile-drawer");
        const qtyWrapper = document.querySelector(".drawer-qty");
        if (drawer && qtyWrapper) {
          clearInterval(iv);
          cb(drawer, qtyWrapper);
        }
      }, 150);
    };

    waitForDrawer((drawer, qtyWrapper) => {
      const buybtn = drawer?.querySelector(".ghost-btn.onetime");
      if(buybtn) {
        buybtn.textContent = "add to cart";
      }
    });

    function waitForLoopWidget(callback) {
        const checkExist = setInterval(() => {
        const loopContainer = document.querySelector(".loop-widget-container");
        const hasOptions = loopContainer && loopContainer.querySelectorAll(".loop-widget-purchase-option").length > 0;
        if (hasOptions) {
            clearInterval(checkExist);
            callback(loopContainer);
        }
        }, 250);
    }

    waitForLoopWidget(loopContainer => {
      setTimeout(() => {
        const addtocartBtn = document.querySelector(".product-buy-buttons--cta-text");
        if (addtocartBtn) addtocartBtn.textContent = "add to cart";
      }, 150);
    });
    

  }

  // run once
  hideSub();

  // watch for dynamically added elements
  const observer = new MutationObserver(() => {
    hideSub();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

*/

/* Crisp */
$crisp.push(["do", "chat:hide"]);
$crisp.push(["on", "chat:closed", function() {
  $crisp.push(["do", "chat:hide"]);
}]);

document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector('a[href="#crisp-show"]');

  if (trigger) {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      if (window.$crisp) {
        $crisp.push(["do", "chat:show"]);
        $crisp.push(["do", "chat:open"]);
      }
    });
  }
});